import React, { useState } from "react";
import { DeviceSetting } from "./";
import { ModalComp } from "../";
import { FiHardDrive } from "react-icons/fi";

const Device = ({ device }) => {
  const [deviceSettingOpen, setdeviceSettingOpen] = useState(false);
  const toggledeviceSetting = () => setdeviceSettingOpen(!deviceSettingOpen);
  return (
    <>
      <ModalComp
        modal={deviceSettingOpen}
        toggle={toggledeviceSetting}
        component={<DeviceSetting device={device} />}
        dark={true}
      />
      <div className="col-lg-5 col-md-5 col-sm-10 col-10 mb-3 p-3 deviceView">
        <div className="mb-2 d-flex justify-content-between">
          <i
            className={`deviceViewImg d-flex cursor align-items-center justify-content-center text-center bg-white`}
          >
            {/* <img src={`https://assessn.mmaviot.com/${device.category.image}`} className="w-75" /> */}
            {device.category.image !== "MPX4.jpg" ? (
              <img src={device.category.image} className="w-75" />
            ) : (
              <FiHardDrive />
            )}
          </i>
          <label className="switchDevice">
            <input
              type="checkbox"
              id="myCheck"
              defaultChecked={false}
              // onChange={visibleChanged}
            />
            <span className="switchSliderDevice round"></span>
          </label>
        </div>
        <b className="fn12 pt-2">{device.caption}</b>
        <small className="text-muted d-block fn10 py-2">
          {device.category.description}
        </small>
        <i
          onClick={toggledeviceSetting}
          className="icon-ellipsis-vert p-1 detailIconRotate cursor"
        ></i>
      </div>
    </>
  );
};

export { Device };
